<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: "Radar",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "170px"
    },
    colorList: {
      type: Array,
      default() {
        return ["#1d89ff", "#00cdff", "#4be8ca", "#eecf50", "#ff7352"];
      }
    },
    center: {
      type: Object,
      default() {
        return {
          x : "35%",
          y : "50%"
        };
      }
    },
    legendRight: {
      type: Number,
      default: 20
    },
    chartData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
      chartData() {
          if (this.chart) {
              this.chart.dispose();
              this.chart = null;
          }
          this.initChart();
      }
  },
  methods: {
    initChart() {
      let indicator = [];
      for (let i = 0; i < this.chartData.nameList.length; i++) {
        let temp = {};
        temp.name = this.chartData.nameList[i];
        indicator.push(temp);
      }
      let seriesData = [];
      for (let i = 0; i < this.chartData.data.length; i++) {
        let temp = {
          value: this.chartData.data[i].valueList,
          name: this.chartData.data[i].legend,
          itemStyle: {
            normal: {
              color: this.colorList[i]
            }
          }
        };
        seriesData.push(temp);
      }

      var option = {
        legend: {
          orient: "vertical",
          y: "center",
          right: this.legendRight,
          itemGap: 18,
          icon: "rect",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#cbeeff"
          }
        },
        tooltip: {
          confine: true
        },
        radar: {
          center: [this.center.x, this.center.y],
          name: {
            textStyle: {
              color: "#cbeeff"
            }
          },
          nameGap: 10,
          axisLine: {
            // 坐标轴线
            show: true, // 默认显示，属性show控制显示与否
            lineStyle: {
              width: 1,
              color: "rgba(64,171,221,0.2)"
            }
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ["none", "rgba(64,171,221,0.2)"] // 图表背景网格的颜色
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(64,171,221,0.2)" // 图表背景网格线的颜色
            }
          },
          indicator: indicator
        },
        series: [
          {
            type: "radar",
            symbol: "none",
            data: seriesData
          }
        ]
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(option);
    }
  }
};
</script>
<style scoped lang="less">
.chart {
  width: 100% !important;
  height: 100% !important;
}
</style>
